module.exports = __webpack_public_path__ + "b28c6dd7ba2b048bcc27d1149039dd60.pdf";